import React from 'react'
import PhoneNumberContext from '../context/PhoneNumberHubContext'
import PropTypes from 'prop-types'

function PhoneNumberHubProvider(props) {
    const {getCustomers} = props

    return (
        <PhoneNumberContext.Provider
            value={{
                getCustomers,
            }}
        >
            {props.children}
        </PhoneNumberContext.Provider>
    )
}

PhoneNumberHubProvider.propTypes = {
    getCustomers: PropTypes.func.isRequired
}

export default PhoneNumberHubProvider
